"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const lipstick = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-lipstick` : '') + (description ? ` desc-lipstick` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-lipstick"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-lipstick"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2074)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 13.75a.25.25 0 0 0-.25-.25h-7a.25.25 0 0 0-.25.25v8.75H9v-8.75Zm1.5 9A1.25 1.25 0 0 1 9.25 24h-8A1.25 1.25 0 0 1 0 22.75v-9A1.75 1.75 0 0 1 1.75 12h7a1.75 1.75 0 0 1 1.75 1.75v9Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.75 10.5v.4-.4h.08a1.36 1.36 0 0 1 .5.14 1.19 1.19 0 0 1 .67 1.11v11h-.75.75v.08a1.33 1.33 0 0 1-.14.5 1.19 1.19 0 0 1-1.11.67h-8v-.75.75h-.08a1.33 1.33 0 0 1-.5-.14 1.19 1.19 0 0 1-.67-1.11v-11h.75-.75v-.08a1.33 1.33 0 0 1 .14-.5 1.19 1.19 0 0 1 1.11-.67h8ZM15 22.5h7.5V12H15v10.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.5 12.75V2.25a1.5 1.5 0 0 1 2.4-1.2L8.1 4.2A2.25 2.25 0 0 1 9 6v6.75a.75.75 0 0 1-1.5 0V6a.75.75 0 0 0-.3-.6L3 2.25v10.5a.75.75 0 0 1-1.5 0Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.25 19.5a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5h9Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2074"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = lipstick;